export const SHOW_REFER_POPUP_MODAL = "SHOW_REFER_POPUP_MODAL";
export const SHOW_REFER_SIGN_UP_STATUS_POPUP_MODAL =
  "SHOW_REFER_SIGN_UP_STATUS_POPUP_MODAL";
export const SET_REFERRAL_DATA = "SET_REFERRAL_DATA";
export const SHOW_REFER_SIGN_UP_TO_GET_REWARDS =
  "SHOW_REFER_SIGN_UP_TO_GET_REWARDS";
export const SET_REFER_FIRST_NAME = "SET_REFER_FIRST_NAME";
export const SET_REFER_COUPON = "SET_REFER_COUPON"